import { CSSTransition } from 'react-transition-group';

import { useState } from '@hookstate/core';

import { useOutsideClickRef } from 'rooks';

import { IProduct } from '@models/Product.model';
import React from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { ShowSelectedFieldsContent } from './components';

import {
  Container,
  ProductsText,
  Block,
  Icon,
} from './ShowSelectedFields.styles';

interface IProps {
  listOfProducts: IProduct[];
  setListOfProducts: (list: IProduct[]) => void;
}
const ShowSelectedFields = ({ listOfProducts, setListOfProducts }: IProps) => {
  const open = useState(false);

  const [addFieldRef] = useOutsideClickRef(() => {
    open.set(false);
  });

  return (
    <Container ref={addFieldRef}>
      <ProductsText type="button" onClick={() => open.set(true)}>
        {`${listOfProducts.length} Products`}
        <Icon icon={faChevronDown} />
      </ProductsText>

      <CSSTransition
        in={open.get()}
        timeout={300}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      >
        <Block>
          <ShowSelectedFieldsContent
            openAddField={open}
            listOfProducts={listOfProducts}
            setListOfProducts={setListOfProducts}
          />
        </Block>
      </CSSTransition>
    </Container>
  );
};

export { ShowSelectedFields };
